import { normalizeLocale, isLocale, type Locale } from '@/i18n/locales';

type TranslationPrimitive = string | number | boolean | null | undefined;
export type TranslationValues = Record<string, TranslationPrimitive>;

let activeLocale: Locale = 'en';
let activeMessages: Record<string, unknown> = {};

export function setClientTranslationCatalog(
  locale: string,
  messages: Record<string, unknown>,
): void {
  activeLocale = normalizeLocale(locale);
  activeMessages = messages;
}

export function getCurrentLocale() {
  if (typeof document !== 'undefined') {
    const documentLang = document.documentElement.lang;
    if (documentLang) return normalizeLocale(documentLang);

    const localeCookie = document.cookie
      .split('; ')
      .find((item) => item.startsWith('NEXT_LOCALE='))
      ?.split('=')[1];
    if (isLocale(localeCookie)) return localeCookie;
  }

  return activeLocale;
}

function getNestedValue(source: unknown, path: string) {
  return path.split('.').reduce<unknown>((current, segment) => {
    if (!current || typeof current !== 'object') {
      return undefined;
    }

    return (current as Record<string, unknown>)[segment];
  }, source);
}

function interpolate(template: string, values?: TranslationValues) {
  if (!values) return template;

  return template.replace(/\{(\w+)\}/g, (_, key: string) => {
    const value = values[key];
    return value === null || value === undefined ? '' : String(value);
  });
}

export function translateClient(namespace: string, key: string, values?: TranslationValues) {
  const locale = getCurrentLocale();
  const template = locale === activeLocale
    ? getNestedValue(activeMessages, `${namespace}.${key}`)
    : undefined;

  if (typeof template !== 'string') {
    return '';
  }

  return interpolate(template, values);
}
